import { useEffect, useState } from 'react';
import { useParticipants } from './ParticipantsContext.js';
import Filter from "../../../components/Filter/Filter.js";
import { useTranslation } from 'react-i18next';
import StatusMessage from "../../../components/StatusMessage/StatusMessage.js";

const ParticipantsView = () => {
  const { t } = useTranslation();
  const { participants, loading, error, fetchParticipants } = useParticipants();
  const [filteredParticipants, setFilteredParticipants] = useState(participants);
  
  useEffect(() => {
    fetchParticipants();
  }, [fetchParticipants]);

  useEffect(() => {
    setFilteredParticipants(participants);
  }, [participants]);

  const handleSearch = (filters) => {
    let filtered = [...participants];

    if (filters.country) {
      filtered = filtered.filter((p) => p.country === filters.country);
    }
    if (filters.groupName) {
      filtered = filtered.filter((p) =>
        p.groupName?.toLowerCase().includes(filters.groupName.toLowerCase())
      );
    }
    if (filters.playerName) {
      filtered = filtered.filter((p) =>
        p.playerName.toLowerCase().includes(filters.playerName.toLowerCase())
      );
    }
    if (filters.genderLabel) {
      filtered = filtered.filter((p) => p.genderLabel === filters.genderLabel);
    }
    if (filters.attendanceLabel) {
      filtered = filtered.filter(
        (p) => p.attendanceLabel === filters.attendanceLabel
      );
    }

    setFilteredParticipants(filtered);
  };

  if (loading) return <StatusMessage type="loading" />;
  if (error) return <StatusMessage type="error" description={error} />;

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Filter
          onSearch={handleSearch}
          showGroupName={true}
          showGender={true}
          showAttendance={true}
        />
      </div>
      <div className="table-wrap">
        <div className="table-shadow">
          <table>
            <colgroup>
              <col width="3%" />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan="2">{t("table.index")}</th>
                <th rowSpan="2">{t("positions.player")}<br />No.</th>
                <th rowSpan="2">{t("table.country")}</th>
                <th rowSpan="2">{t("table.team-name")}</th>
                <th rowSpan="2">{t("table.player-name")}</th>
                <th rowSpan="2">{t("common.gender")}</th>
                <th rowSpan="2">{t("table.position")}</th>
                <th colSpan="4">{t("table.event-team")}</th>
                <th colSpan="4">{t("table.event-individual")}</th>
                <th rowSpan="2">{t("table.remarks")}</th>
                <th rowSpan="2">{t("table.status")}</th>
              </tr>
              <tr>
                <th>30</th>
                <th>70</th>
                <th>90</th>
                <th>145</th>
                <th>30</th>
                <th>70</th>
                <th>90</th>
                <th>145</th>
              </tr>
            </thead>
            <tbody>
              {filteredParticipants.map((participant, index) => (
                <tr key={participant.playerId}>
                  <td>{index + 1}</td>
                  <td>{participant.playerNumber}</td>
                  <td>{participant.country}</td>
                  <td>{participant.groupName}</td>
                  <td>{participant.playerName}</td>
                  <td>{participant.genderLabel}</td>
                  <td>{participant.positionLabel}</td>
                  <td>{participant.groupEvents?.distance30 ?? ""}</td>
                  <td>{participant.groupEvents?.distance70 ?? ""}</td>
                  <td>{participant.groupEvents?.distance90 ?? ""}</td>
                  <td>{participant.groupEvents?.distance145 ?? ""}</td>
                  <td>{participant.individualEvents?.distance30 ?? ""}</td>
                  <td>{participant.individualEvents?.distance70 ?? ""}</td>
                  <td>{participant.individualEvents?.distance90 ?? ""}</td>
                  <td>{participant.individualEvents?.distance145 ?? ""}</td>
                  <td>{participant.note}</td>
                  <td>{participant.attendanceLabel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="table-gradient"></div>
      </div>
    </>
  );
};
export default ParticipantsView;
